// You can customize the template with the help of this file
import logoImageWebP from '@src/assets/logo-192.webp'
import logoImagePNG from '@src/assets/logo 192.png'

//Template config options
const themeConfig = {
  app: {
    appName: 'Bitazar',
    appLogoImage: logoImageWebP, // WebP format - 76% smaller than PNG
    appLogoImageFallback: logoImagePNG // PNG fallback for older browsers
  },
  layout: {
    isRTL: true,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoomIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true // Changed to true - sidebar collapsed by default
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'hidden' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: false // Enable scroll to top button
  }
}

export default themeConfig
